<div class="eb-order-confirmation-message" data-cy="order-confirmation">
  <h2>{{ 'checkoutOrderConfirmation.thankYou' | cxTranslate }}</h2>
  <p>
    {{ 'checkoutOrderConfirmation.invoiceHasBeenSentByEmail' | cxTranslate }}
  </p>
</div>
